import React from "react";
import "./FrameSizeIcon.css";

// A small rectangle scaled to the frame's real aspect ratio, so 5x7 visibly
// reads as a different shape than 16x20 instead of just two numbers.
function FrameSizeIcon({ widthInches, heightInches, boxSize = 44 }) {
  const w = parseFloat(widthInches) || 1;
  const h = parseFloat(heightInches) || 1;
  const ratio = w / h;
  const rectW = ratio >= 1 ? boxSize : boxSize * ratio;
  const rectH = ratio >= 1 ? boxSize / ratio : boxSize;

  return (
    <div className="fsi-box" style={{ width: boxSize, height: boxSize }}>
      <div className="fsi-frame" style={{ width: rectW, height: rectH }}>
        <div className="fsi-photo" />
      </div>
    </div>
  );
}

export default FrameSizeIcon;
